import React, { useState, useEffect } from 'react';
import CareerCard from './CareerCard';

export default function CareerPost({ careerPost }) {
    const [careerPosts, setCareerPosts] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const cardsPerPage = 4;

    useEffect(() => {
        if (careerPost) {
            setCareerPosts(careerPost);
            console.log("Career posts received:", careerPost);
        }
    }, [careerPost]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + cardsPerPage) % careerPosts.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - cardsPerPage + careerPosts.length) % careerPosts.length);
    };

    const getVisibleCards = () => {
        let visibleCards = [];
        for (let i = 0; i < cardsPerPage; i++) {
            const post = careerPosts[(currentIndex + i) % careerPosts.length];
            if (post) {
                visibleCards.push(post);
            }
        }
        return visibleCards;
    };

    return (
        <div className="min-h-screen bg-gray-50 font-sans text-gray-900 flex flex-col items-center py-16 px-4 sm:px-6 lg:px-8 ">
            <div className="text-center mb-12 max-w-2xl">
                <h1 className="text-4xl sm:text-5xl font-extrabold text-gray-800 tracking-tight mb-4">
                    Current Vacancies
                </h1>
                <p className="text-lg text-gray-600 leading-relaxed">
                    We offer uncapped salary potential, incentives and rewards, and ongoing support from our managers
                    and trainers. Whether you're just starting your career or looking to make a change, we want to hear from
                    you.
                </p>
            </div>

            <div className="relative w-full max-w-7xl mx-auto">
                {/* Navigation Arrows */}
                <button
                    onClick={handlePrev}
                    className="absolute left-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md z-10 hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#173d73] focus:ring-offset-2 -ml-6 sm:-ml-10"
                    aria-label="Previous Vacancy"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700"><path d="m15 18-6-6 6-6" /></svg>
                </button>

                <button
                    onClick={handleNext}
                    className="absolute right-0 top-1/2 -translate-y-1/2 bg-white p-3 rounded-full shadow-md z-10 hover:bg-gray-100 transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-[#173d73] focus:ring-offset-2 -mr-6 sm:-mr-10"
                    aria-label="Next Vacancy"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-gray-700"><path d="m9 18 6-6-6-6" /></svg>
                </button>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 p-4">
                    {getVisibleCards().map((post) => (
                        <CareerCard
                            key={post.id}
                            id={post.id}
                            job={post.job}
                            location={post.location}
                            imageUrl={post.image}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
